// extracted by mini-css-extract-plugin
export var container = "_3g-0";
export var icon = "_3g-1";